import { Component, Input, OnInit } from '@angular/core';
import { BusinessSummary } from '../models/business-summary.model';
import {BusinessManagerService} from '../../shared/user/business-manager.service';
import {
  getAwardName,
  getAwardYear,
  getBadgeImageUrl,
  getCurrentFteAwardTags,
  getHistoricalFteAwardTags,
  hasTag
} from '../../util/tag-utils';
import { ReportCardPdfService } from '../../shared/services/report-card-pdf.service';
import { Tag } from '../../shared/models/tag.model';


@Component({
  selector: 'app-business-summary',
  templateUrl: './business-summary.component.html',
  styleUrls: ['./business-summary.component.scss']
})
export class BusinessSummaryComponent implements OnInit {
  isFlightDeckAdmin = false;
  displayReportCard = false;
  displayHistoricalBadges = false;
  tagsToDisplay: Tag[];
  oldTagsToDisplay: Tag[];
  @Input() business: BusinessSummary;
  @Input() fteAwardYear: string;
  constructor(private businessManagerService: BusinessManagerService,
              private reportCardPdfService: ReportCardPdfService) { }

  async ngOnInit() {
    this.isFlightDeckAdmin = await this.businessManagerService.isFlightDeckAdmin();
    this.displayHistoricalBadges = hasTag(this.business.fteAwardTags, 'Admin::Flight Training::Display Prior Year Badges');
    this.displayReportCard = hasTag(this.business.fteAwardTags, 'Admin::Flight Training::Display Customer Feedback Report');

    // remove control tags from the list
    this.business.fteAwardTags = this.business.fteAwardTags.filter(t => t.tagName.includes('Awards::Flight Training::'));

    if (this.displayHistoricalBadges) {
      this.tagsToDisplay = getCurrentFteAwardTags(this.business.fteAwardTags);
      this.oldTagsToDisplay = getHistoricalFteAwardTags(this.business.fteAwardTags);
    } else {
      this.tagsToDisplay = getCurrentFteAwardTags(this.business.fteAwardTags);
      this.oldTagsToDisplay = [];
    }
  }

  get hasServices(): boolean {
    return this.business && (
      this.business.maintenance
      || this.business.rental.planes
      || this.business.rental.rotorcraft
      || this.business.rental.cars
      || this.business.rental.equipment
      || this.business.sales
      || this.business.flightTraining
      || this.business.fuel.length > 0
    );
  }

  get listingBackground(): string {
    if (this.isFlightDeckAdmin && this.business.hideBusiness) {
      return 'not-ok';
    } else if (this.isFlightDeckAdmin && this.business.notApproved) {
      return 'not-approved';
    } else {
      return 'business-summary';
    }
  }

  /**
   * Returns fees that are applicable to this FBO.
   */
  get fboFees(): string {
    let result: string[] = [];
    if (this.business.isFbo) {
      let hasOther = false;
      const feesWanted: string[] = ['Ramp', 'Hangar', 'Tie Down', 'Landing', 'Overnight', 'Handling', 'Parking'];
      if (this.business.feeTypes != null) {
        for (const busFee of this.business.feeTypes) {
          for (const currentFee of feesWanted) {
            if (busFee === currentFee) {
              result.push(busFee);
            } else {
              hasOther = true;
            }
          }
        }
      }
      //  Filters array by uniqueness
      result = result.filter((value, i, self) => self.indexOf(value) === i).sort();
      if (hasOther) {
        result.push('Other');
      }
    }
    return result.join(', ');
  }

  getAwardName(tagName: string): string {
    return getAwardName(tagName);
  }

  getBadgeImageUrl(tagName: string): string {
    return getBadgeImageUrl(tagName);
  }

  clickReportCard() {
    this.reportCardPdfService.getReportCardPdf(this.business.id, this.fteAwardYear).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, '_blank');
    });
  }

  getReportCardBadgeUrl(): string {
    return 'https://www.aopa.org/-/media/Images/passport/2023/FTSurvey/2206_Flight_School_Report_Card%20Badge_400x400';
  }
}
